module.exports = __webpack_public_path__ + "img/ponentes.cac3f5b4.png";